import { render, staticRenderFns } from "./EditClasses.vue?vue&type=template&id=d80ee0b0&scoped=true"
import script from "./EditClasses.vue?vue&type=script&lang=js"
export * from "./EditClasses.vue?vue&type=script&lang=js"
import style0 from "./EditClasses.vue?vue&type=style&index=0&id=d80ee0b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80ee0b0",
  null
  
)

export default component.exports